module.exports = "/static/assets/1e4fc169fa222ff92a543c090adab467.png";